import { Col, Row } from "antd";
import React, { useState } from "react";
import "./index.scss";

const dataRoles = [
  {
    role: "Solutions Architect",
  },
  {
    role: "Java Architect",
  },
  {
    role: "Microsoft Stack",
  },
  {
    role: "Open Source Technologies",
  },
  {
    role: "Project Management",
  },
];

const Services = () => {
  const [selectedRole, setSelectedRole] = useState("Solutions Architect");

  const solutionArchitect = () => {
    return (
      <>
        <div className="roles-main">
          <div className="roles-header">Solutions Architect</div>
          <div className="roles-desc">
            We bring our expertise and skillsets in multiple domains to provide
            Solutions Architect through our IT Personnels. We have provided
            solutions for:
          </div>
          <ul className="roels-list">
            <li>Data</li>
            <li>Cloud</li>
            <li>Engineering</li>
          </ul>
        </div>
      </>
    );
  };

  const javaArchitect = () => {
    return (
      <>
        <div className="roles-main">
          <div className="roles-header">Java Architect</div>
          <div className="roles-desc">
            Our Java Architects are well versed with latest technologies who
            have helped our customers to grow, sustain and transform their
            businesses in the ever evolving situations in today’s world. Our
            Open Source Digital Capabilities are helpful to respond to market
            disruptions without interrupting your core competencies.
          </div>
        </div>
      </>
    );
  };

  const microSoftStack = () => {
    return (
      <>
        <div className="roles-main">
          <div className="roles-header">Microsoft Stack</div>
          <div className="roles-desc">
            With many years of experience of Microsoft Stack like .Net, Azure
            Cloud Platform, Sharepoint and MS Office Products. We help our
            customers to become more resilient, increase their efficiency,
            reduce costs, improve the quality of services and products. As a
            result, our customers have more competitive edge and increased
            customer satisfaction.
          </div>
        </div>
      </>
    );
  };

  const projectManagement = () => {
    return (
      <>
        <div className="roles-main">
          <div className="roles-header">Project Management:</div>
          <div className="roles-desc">
            We have provided Project Management through our personnel to the
            Government sectors and many state projects in Healthcare, Finance &
            Telecom Domain. Our Project Management team brings holistic approach
            to integrate technology with talent transformation and hiring.
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="servicespage-main">
      {/* Banner */}
      <div id="banner-area">
        <div className="about-overlay"></div>
        <div className="banner-title-content">
          <h2>About Services</h2>
        </div>
      </div>

      {/* Main */}

      {/* Consulting */}

      <Row className="consulting-services-main">
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 22, offset: 2 }}
          lg={{ span: 22, offset: 2 }}
          xl={{ span: 22, offset: 2 }}
        >
          <h2 className="header">
            <span>
              <img src="/images/icons/discussion.png" alt="" />
            </span>
            Consulting Services
          </h2>
        </Col>
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 2 }}
          lg={{ span: 10, offset: 2 }}
          xl={{ span: 10, offset: 2 }}
        >
          <div className="consulting-services-image"></div>
        </Col>
        <Col
          sm={{ span: 22, offset: 2 }}
          xs={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 0 }}
          lg={{ span: 10, offset: 0 }}
          xl={{ span: 10, offset: 0 }}
        >
          <div className="consulting-services-text-container">
            <p>
              Computer Data Concepts Inc provides IT & Non IT Staffing
              Consulting Services across Healthcare, Retail, Pharma, Finance and
              Telecom.
            </p>
            <p>
              We deliver timely and cost-effective solutions to complex business
              problems.
            </p>
          </div>
        </Col>
      </Row>

      {/* Staffing */}
      <Row className="staffing-services-main">
        <Col
          xs={{ span: 22, offset: 2 }}
          sn={{ span: 22, offset: 2 }}
          md={{ span: 22, offset: 2 }}
          lg={{ span: 22, offset: 2 }}
          xl={{ span: 22, offset: 2 }}
        >
          <h2 className="header">
            <span>
              <img src="/images/icons/group.png" alt="" />
            </span>
            Staffing Services
          </h2>
        </Col>
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 2 }}
          lg={{ span: 10, offset: 2 }}
          xl={{ span: 10, offset: 2 }}
        >
          <div className="staffing-services-text-container">
            <h5>Our staffing services span across:</h5>

            <ul className="check-list">
              <li>Information Technology</li>
              <li>Project Management</li>
              <li>Advisory</li>
              <li>Customized IT Solutions</li>
            </ul>

            <p>
              20+ years of proven experience working with IT & Non-IT
              professionals.
            </p>
            <p>We support W2 and Corp-to-Corp hiring models.</p>
          </div>
        </Col>
        <Col
          sm={{ span: 22, offset: 2 }}
          xs={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 0 }}
          lg={{ span: 10, offset: 0 }}
          xl={{ span: 10, offset: 0 }}
        >
          <div className="staffing-services-image"></div>
        </Col>
      </Row>

      {/* Technology */}
      <Row className="technology-services-main">
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 22, offset: 2 }}
          lg={{ span: 22, offset: 2 }}
          xl={{ span: 22, offset: 2 }}
        >
          <h2 className="header">
            <span>
              <img src="/images/icons/technology.png" alt="" />
            </span>
            Technology Services
          </h2>
        </Col>
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 20, offset: 2 }}
          lg={{ span: 20, offset: 2 }}
          xl={{ span: 20, offset: 2 }}
        >
          <div className="technology-services-text-container">
            <p>
              We specialize and boast about our Technology Services across many platforms. Starting from Analysis , Planning, Coding and Architecture. Our clients have given us repeat business by hiring our IT Personnel’s in these areas.
            </p>
          </div>
        </Col>
      </Row>

      {/* Tabs Section */}

      <Row className="roles-main-container">
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 2 }}
          lg={{ span: 5, offset: 2 }}
          xl={{ span: 5, offset: 2 }}
        >
          <ul className="role-lists">
            {dataRoles.map((role) => {
              return (
                <li key={role.role}>
                  <div className={`clickable-roles ${selectedRole === role.role && 'current-role'}`}
                  onClick={() => setSelectedRole(role.role)}>
                    {role.role}
                  </div>
                </li>
              );
            })}
          </ul>
        </Col>
        <Col
          xs={{ span: 22, offset: 2 }}
          sm={{ span: 22, offset: 2 }}
          md={{ span: 10, offset: 2 }}
          lg={{ span: 15, offset: 2 }}
          xl={{ span: 15, offset: 2 }}
          className="role-desc-container"
        >
          {selectedRole === "Solutions Architect" && solutionArchitect()}
          {selectedRole === "Java Architect" && javaArchitect()}
          {selectedRole === "Microsoft Stack" && microSoftStack()}
          {selectedRole === "Open Source Technologies" && solutionArchitect()}
          {selectedRole === "Project Management" && projectManagement()}
        </Col>
      </Row>
    </div>
  );
};

export default Services;
